import {
  DefaultButton,
  Panel,
  PanelType,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import { useCallback } from "react";
import { PanelHeader } from "../../components/Panel/PanelHeader";
import { ComboBoxIDS } from "../../components/generic/ComboBoxIDS";
import { useComboAreas } from "../../hooks/combosHooks/useComboAreas";
import {
  ITableFilterPersonas,
  IfilterPersona,
} from "../../Interfaces/IPersona";
import { useComboGuardias } from "../../hooks/combosHooks/useComboGuardias";
import { PanelFooter } from "../../components/Panel/PanelFooter";
import { useComboPuestos } from "../../hooks/combosHooks/usePuesto";

interface IPanelFilterPersonasView {
  isOpen: boolean;
  onDismiss: () => void;
  onChangeComboBox: (e, o, nombre) => void;
  filter: ITableFilterPersonas;
  limpiarFiltro: () => void;
  buscar: () => void;
}
export const PanelFilterPersonasView = (props: IPanelFilterPersonasView) => {
  const { _onKeyUpSearchArea, comboBoxAreaRef, dataComboArea, onClickOpen } = useComboAreas();
  const { comboBoxRefGuardias, dataComboGuardia, onClickOpenGuardias } = useComboGuardias();
  const { dataComboPuesto, _onKeyUpSearchPuesto, comboBoxPuestoRef, onClickOpenPuesto } = useComboPuestos();

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.buscar}
          disableButton={false}
          onDismiss={props.limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );

  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro de Personas"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );

  return (
    <>
      <Panel
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.smallFixedFar}
        isLightDismiss
        onRenderHeader={onRenderHeaderPanel}
        onRenderFooter={onRenderFooterPanel}
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <br />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <ComboBoxIDS
                title="Área:"
                componentRef={comboBoxAreaRef}
                KeyUp={_onKeyUpSearchArea}
                selectedKey={props.filter?.areaId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "area");
                }}
                onClick={onClickOpen}
                options={dataComboArea}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <ComboBoxIDS
                title="Guardia:"
                componentRef={comboBoxRefGuardias}
                selectedKey={props.filter?.guardia}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "guardia");
                }}
                onClick={onClickOpenGuardias}
                options={dataComboGuardia}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <ComboBoxIDS
                key={props.filter.puestoId ?? "puesto-null"}
                title="Puesto:"
                componentRef={comboBoxPuestoRef}
                KeyUp={_onKeyUpSearchPuesto}
                selectedKey={props.filter.puestoId ?? undefined}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "puesto");
                }}
                onClick={onClickOpenPuesto}
                options={dataComboPuesto}
              />
            </div>
          </div>
        </div>
      </Panel>
    </>
  );
};
